"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _currency = require("@nerdwallet/currency");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chicletModule = _interopRequireDefault(require("./chiclet.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var colorMap = {
  green: 'green-dark',
  'neutral-darkest': 'neutral-darkest',
  red: 'red-dark'
};

var Chiclet = function Chiclet(_ref) {
  var color = _ref.color,
      text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_chicletModule["default"]["tab-container"], _chicletModule["default"]["tab-container__".concat(color)])
  }, /*#__PURE__*/_react["default"].createElement(_currency.Type, {
    size: 1,
    color: colorMap[color],
    bold: true
  }, text));
};

Chiclet.defaultProps = {
  color: 'neutral-darkest',
  text: ''
};
Chiclet.propTypes = {
  color: _propTypes["default"].oneOf(['green', 'neutral-darkest', 'red']),
  text: _propTypes["default"].string
};
var _default = Chiclet;
exports["default"] = _default;